import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _PayrollDocumentCatalog } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PayrollDocumentTypeSelect } from "../../../ParametrosTalentoHumano/PayrollFactor/PayrollDocumentType/PayrollDocumentTypeSelect";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { FileInput } from "../../../../theme/Component/FileInput";
import { FileService } from "../../../../../core/services/FileService";
interface Props {
    idContract: number;
}


export const PayrollDocumentCatalog = ({ idContract }: Props) => {

    const documentcatalog = useDataBean(_PayrollDocumentCatalog);
    const single = Singleton.getInstance();
    const fileService = new FileService();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalagregar, setModalagregar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idContract])

    const getLista = () => {

        documentcatalog.instance.getPayrollDocumentCatalog(idContract).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>Ver</a>`
                        } else {
                            element.DataBeanProperties.URL = "";
                        }
                    });
                    setLista(tmp);
                } else {
                    toast.error('Algo Salio Mal')
                }
            }
        )

    }

    const create = () => {
        documentcatalog.setBean({
            IDContract: idContract
        });
        // setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        documentcatalog.deleteItemVoid(documentcatalog.bean.IDPayrollDocument).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const abririagregar = () => {


        setModalagregar({ ...modalagregar, "view": true });

    }
    const addPayrollDocument = () => {

        documentcatalog.instance.addPayrollDocument(idContract, documentcatalog.bean.IDPayrollDocumentType, documentcatalog.bean.Media, documentcatalog.bean.MediaContext, documentcatalog.bean.Observations, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Agregado')
                getLista();
                setModalagregar({ ...modalagregar, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDPayrollDocument', visible: true },
        { title: 'Tipo de Documento', property: 'Name', visible: true },
        { title: 'Actualizó', property: 'EmployeeName', visible: true },
        { title: 'Adjunto', property: 'URL', visible: true },
        { title: 'Fecha Actualización', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${documentcatalog.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Documentos/Expedientes Laborales/Actos Administrativos">
            <div className="row">
                <div className="col-md-4">
                    <BasicButton icon="ri-file-add-line" eventClick={abririagregar}>Agregar  Documentos*</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={documentcatalog.setBean} listButtons={listaBotones()}></BasicTable>
                    <Modal modal={modalagregar} updateModal={setModalagregar} eventModal={addPayrollDocument}>
                        <div className="row">
                            <div className="col-md-12">
                                <PayrollDocumentTypeSelect idSelector={documentcatalog.bean.IDPayrollDocumentType} onChange={(e: any) => { documentcatalog.setBean({ ...documentcatalog.bean, "IDPayrollDocumentType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <FileInput Media={documentcatalog.bean.Media} MediaContext={documentcatalog.bean.MediaContext} directory="docsdocumentcatalogpayroll" label="Cargar Documento" onCreate={({ MediaContext, Media }: any) => { documentcatalog.setBean({ ...documentcatalog.bean, Media: Media, MediaContext: MediaContext }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="ClassForName" className="form-control" value={documentcatalog.bean.Observations} onChange={documentcatalog.handleChange} />
                            </div>
                        </div>

                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {documentcatalog.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}